import React from 'react';

const KotReturnBillPrint = ({
  invoiceNumber,
  selectedPatient,
  selectedDoctor,
  date,
  products,
  balance_due,
  calculateTotal,
  calculateTotalDiscount,
  calculateTotalGST,
  generalSetting,
  username,
  payingAmount
}) => {

  // Filter valid products for KOT
  const validProducts = products.filter(product => product.id && product.name);

  const createDashedLine = (width = 43) => {
    return '-'.repeat(width);
  };

  return (
    <div className="flex h-screen bg-background">
      <div className="p-4 bg-gray-500">
        <div
          id="kotDiv"
          className="bg-white p-2 font-mono text-sm"
          style={{ 
            width: '302px', // 80mm = ~302px at 96dpi
            minHeight: 'auto',
            fontFamily: 'Courier New, monospace',
            fontSize: '11px',
            lineHeight: '1.1',
            margin: '0 auto',
            boxSizing: 'border-box'
          }}
        >
          {/* Header Section */}
          <div className="text-center">
            <div className="font-bold text-sm leading-tight">{generalSetting?.FirstName} {generalSetting?.LastName}</div>
            <div className="font-bold text-xs leading-tight">{generalSetting?.MobileNo1}</div>
            <div className="font-bold text-xs leading-tight" style={{ wordBreak: 'break-word' }}> {generalSetting?.Place}</div>
          </div>
          <div className="text-center mb-2">
            <div className="font-bold text-sm leading-tight">PHARMACY RETURN BILL</div>
          </div>

          {/* Order Details */}
          <div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Invoice No:</span>
              <span className="font-bold">{invoiceNumber}</span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Date:</span>
              <span className='font-bold'>{date}</span>
            </div>
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
          </div>

          {/* Patient Details */}
          <div>
            <div className="flex justify-between text-xs">
                <span className='font-bold'>DL No.:</span>
                <span className="font-bold text-right" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                    {generalSetting?.dlnum1}
                </span>
            </div>
            <div className="flex justify-between text-xs">
                <span className='font-bold'></span>
                <span className="font-bold text-right" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                    {generalSetting?.dlnum2}
                </span>
            </div>

            <div className="flex justify-between text-xs">
                <span className='font-bold'>GST No.:</span>
                <span className="font-bold text-right" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                    {generalSetting?.GstNo}
                </span>
            </div>

            <div className="flex justify-between text-xs">
              <span className='font-bold'>Name:</span>
              <span className="font-bold text-right" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                {selectedPatient?.PatientName}
              </span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Mobile:</span>
              <span className='font-bold'>{selectedPatient?.MobileNo}</span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Referred By:</span>
              <span className='font-bold text-right' style={{ maxWidth: '60%', wordBreak: 'break-word' }}>
                {selectedDoctor?.label}
              </span>
            </div>
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
          </div>

          {/* Items Section - Fixed Table Structure */}
          <div>
            {/* Fixed Table Header */}
            <div className="text-xs py-1">
              <div className="flex w-full">
                <div className="w-[55%]">
                  <span className='font-bold text-left'>Item Name</span>
                </div>
                <div className="w-[15%]">
                  <span className='font-bold text-center'>Batch</span>
                </div>
                <div className="w-[15%]">
                  <span className='font-bold text-center'>Qty</span>
                </div>
                <div className="w-[15%]">
                  <span className='font-bold text-right'>Amount</span>
                </div>
              </div>
            </div>
            
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
            
            {/* Fixed Product List */}
            {validProducts.map((product, index) => (
              <div key={index} className="mb-2">
                <div className="flex w-full text-xs">
                  <div className="w-[55%]">
                    <span className="font-bold text-left" style={{ wordBreak: 'break-word' }}>
                      {index + 1}.{product?.alt_name || product?.name}
                    </span>
                  </div>
                  <div className="w-[15%]">
                    <span className="font-bold text-center">{product?.batch?.batchNo || '-'}</span>
                  </div>
                  <div className="w-[15%]">
                    <span className="font-bold text-center">{product?.qty}</span>
                  </div>
                  <div className="w-[15%]">
                    <span className="font-bold text-right">₹{product?.amount}</span>
                  </div>
                </div>
              </div>
            ))}
            
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
          </div>

          {/* Totals Section */}
          <div>
            <div className="flex justify-between">
              <span className='font-bold text-lg'>Total:</span>
              <span className='font-bold text-lg'>₹{calculateTotal()}</span>
            </div>
            <div className="flex justify-between">
              <span className='font-bold text-lg'>Total Discount:</span>
              <span className='font-bold text-lg'>₹{calculateTotalDiscount()}</span>
            </div>
            <div className="flex justify-between">
              <span className='font-bold text-lg'>Total GST:</span>
              <span className='font-bold text-lg'>₹{calculateTotalGST()}</span>
            </div>
            <div className="flex justify-between">
              <span className='font-bold text-lg'>Paid Amount:</span>
              <span className='font-bold text-lg'>₹{payingAmount}</span>
            </div>
            <div className="flex justify-between font-bold">
              <span className='font-bold text-lg'>Balance:</span>
              <span className='font-bold text-lg'>₹{balance_due === 0 ? `${balance_due}.00` : balance_due}</span>
            </div>
          </div>

          {/* Footer */}
          <div className="text-xs" style={{ fontFamily: 'monospace' }}>
            {createDashedLine()}
          </div>
          <div className="pt-2 text-center">
            <div className="text-xs mb-1 font-bold">
              Printed By User: {username}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KotReturnBillPrint;